<template>
  <div class="counter-container" :class="showRightArrow && 'right-arrow'" :style="containerStyle">
    <div class="counter-value" :style="valueStyle">{{ value }}</div>
    <el-divider class="divider"></el-divider>
    <div class="counter-label-container">
      <span v-show="showLabel" class="counter-label">{{ $t(labelI18nKey) }}</span>
      <div v-show="!showLabel" class="date">
        <div class="date-container day">
          <span class="date days">
            {{ $t('admin.rpa.label.date.days') }}
          </span>
          <span class="number"  :style="arrowStyle">
            {{ day }}
          </span>
        </div>
        <div class="date-container hour">
          <span class="date hour">
            {{ $t('admin.rpa.label.date.hour') }}
          </span>
          <span class="number"  :style="arrowStyle">
            {{ hour }}
          </span>
        </div>
        <div class="date-container minute">
          <span class="date min">
            {{ $t('admin.rpa.label.date.min') }}
          </span>
          <span class="number"  :style="arrowStyle">
            {{ min }}
          </span>
        </div>
      </div>
    </div>
    <div v-show="showRightArrow" class="right-arrow" :style="arrowStyle" @click="onRightArrowClick">
      <i class="arrow-icon el-icon-arrow-right"></i>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    width: {
      type: String,
      default: '23.5%'
    },
    labelI18nKey: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    valueColor: {
      type: String,
      default: '#606060'
    },
    showRightArrow: {
      type: Boolean,
      default: false
    },
    arrowColor: {
      type: String,
      default: '#ee6a6a'
    },
    minutes: {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      showLabel: true
    }
  },
  computed: {
    containerStyle () {
      return {
        width: this.width
      }
    },
    valueStyle () {
      return {
        color: this.valueColor
      }
    },
    arrowStyle () {
      return {
        color: this.arrowColor
      }
    },
    day () {
      if (this.minutes) {
        return _.padStart(_.toInteger(this.minutes / 1440), '2', '0')
      }
      return '00'
    },
    hour () {
      if (this.minutes) {
        return _.padStart(_.toInteger(this.minutes / 60) % 24, '2', '0')
      }
      return '00'
    },
    min () {
      if (this.minutes) {
        return _.padStart(this.minutes % 60, '2', '0')
      }
      return '00'
    }
  },
  created () {

  },
  methods: {
    onRightArrowClick ($event) {
      this.showLabel = !this.showLabel
    }
  }
}
</script>

<style lang="scss" scoped>
.counter-container {
  display: flex;
  padding: 10px 0;
  border-radius: 3px;
  align-items: center;
  flex-direction: column;
  color: #606060;
  font-size: 14px;
  background: #f7f7f7;
  position: relative;

  &:not(:first-child) {
    margin-left: 2%;
  }

  &.right-arrow {
    padding-right: 20px;
  }

  .counter-value {
    font-size: 18px;
    font-weight: bold;
  }

  .divider {
    width: 30%;
    margin: 10px auto;
    background-color: #232323;
  }

  .counter-label-container {
    flex: 1;
    font-size: 12px;
    padding: 0 5px;
    width: 100%;
    text-align: center;

    .date {
      display: flex;

      .date-container {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;

        .date {
          line-height: 1;
        }

        .number {
          font-size: 16px;
        }
      }
    }
  }

  .right-arrow {
    display: flex;
    height: 100%;
    padding-left: 5px;
    padding-right: 2px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;

    &:hover {
      background: #eeeeee;
    }

    .arrow-icon {
      font-size: 16px;
    }
  }
}
</style>
